<template>
  <div class="boti-intro-information">
    <information button-title="אפשר להמשיך" :button-action="next"
                 img-name="Boti.svg">
      <template v-slot:information-title>
        <span>אנחנו איתך גם ב-</span>
        <img class="whatsapp-icon" :src="require('@/assets/onboarding/icons/whatsapp.svg')"/>
      </template>
      <template v-slot:information-description>
        <div>כחלק מהשירות הבוט שלנו מלווה אותך בהודעות. בכל שלב ניתן לחזור לתהליך ההרשמה דרך הלינק המצורף ב-Whatsapp</div>
      </template>
    </information>
  </div>
</template>
<script>

import { mapActions } from 'vuex';
import Information from './components/Information';
import Segment from '../../../../../Segment';

export default {
  async created() {
    Segment.trackUserGot('WhatsappOptInEntered');
    Segment.trackUserGot('WhatsappOptInEntered_Marketing');
  },
  components: {
    Information,
  },
  name: 'BotiIntro',
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    next() {
      Segment.trackUserInteraction('WhatsappOptInConfirmClicked');
      Segment.trackUserInteraction('WhatsappOptInConfirmClicked_Marketing');
      this.onboardingPageSubmit();
    },
  },
};
</script>

<style lang="scss">
  @import '~base-ui/src/scss/riseup-colors';

  .boti-intro-information {
    height: 100%;

    .information {

      .title {
        display: flex;

        .whatsapp-icon {
          padding-right: 4px;
        }
      }

      .body {
        background-color: $riseup_light_green;
      }
    }
  }

</style>
